import i18n from '@/locale'

/**
 * 会员手机号
 */
export const phoneEncryptionKey = 'cGhvbVBZXNLZXkIA'

/**
 * 会员支付密码
 */
export const passwordEncryptionKey = 'Fz3dcmODA2MT0MQg'

/**
 * http 状态码
 */
export enum HttpStatusCode {
  /**
   * 无权限
   */
  UNAUTHORIZED = 401,
  /**
   * 登录失效
   */
  PAYMENT_REQUIRED = 402,
  /**
   * 404
   */
  NOT_FOUND = 404,
  /**
   * 处接口返回200外的其他情况
   */
  NO_SUCCESS = 100,
  /**
   * 接口正常返回数据
   */
  SUCCESS = 200,
  /**
   * 从缓存返回数据
   */
  CACHE_SUCCESS = 600,
  /**
   * 错误响应
   */
  ERROR_RESPONSE = 500,

  ERROR_RESPONSE_400 = 400, // 400错误响应
}

export enum GlobalEventType {
  /**
   * 保存表单
   */
  SAVE = 'SAVE',
  /**
   * 打印
   */
  PRINT = 'PRINT',
  /**
   * 新增
   */
  ADD = 'ADD',
  /**
   * 入账
   */
  RECORDING = 'RECORDING',
  /**
   * 快速添加
   */
  FAST_ADD = 'FAST_ADD',
  /**
   * 取消/返回
   */
  CANCEL = 'CANCEL',
  /**
   * 列表切换 上
   */
  UP = 'UP',
  /**
   * 列表切换 下
   */
  DOWN = 'DOWN',
  /**
   * 刷新数据面板
   */
  FRESH_DUAL_PANE = 'FRESH_DUAL_PANE',
  /**
   * 启用
   */
  ENABLE = 'ENABLE',
  /**
   * 删除
   */
  REMOVE = 'REMOVE',
  /**
   * 更换客户
   */
  CUSTOMER_CHANGE = 'CUSTOMER_CHANGE',
  /**
   * 总部优惠券失效后需重新命中
   */
  REFRESH_HQ_COUPON = 'REFRESH_HQ_COUPON',
}

export enum OperationCode {
  /**
   * 保存
   */
  SAVE = 'SAVE',
  /**
   * 审核
   */
  AUDIT = 'REVIEW',

  /**
   * 反审核
   */
  REAUDIT = 'DECLINE',

  /**
   * 整单结案
   */
  CLOSURE_ORDER = 'SETTLE_CLOSE',

  /**
   * 开始拣货
   * */
  START_PICKING = 'START_PICKING',
  /**
   * 终止
   */
  CLOSE = 'CLOSE',
  /**
   * 退回
   */
  BACKSPACE = 'BACKSPACE',
  /**
   * 生效/入账
   */
  COMPLETE = 'COMPLETE',

  /**
   * 入账
   */
  RECORDING = 'COMPLETE',
}

export const PrintType = {
  // 价签
  PRICE_TAG: 'PRICE_TAG',
  // 小票
  RECEIPT: 'RECEIPT',
}

export const BusinessType = {
  JQ: 'JQ',
  JJB: 'JJB',
  YKD: 'YKD',
  MDDBD: 'MDDBD',
  SYTD: 'SYTD',
  SYDD: 'SYDD',
  CZ: 'CZ',
  TEST: 'TEST',
  QX: 'QX',
  WMDD: 'WMDD',
  WMJH: 'WMJH',
  PFXHD: 'PFXHD',
  /** 批发销货单 A4（与 PFXHD 数据相同，模板为 pfxhd-a4） */
  PFXHD_A4: 'PFXHD_A4',
  /** A4 打印机测试 */
  TEST_A4: 'TEST_A4',
}
export const JsonDBKey = {
  // 打印配置
  PRINT_SETTING: 'PRINT_SETTING',
  // 客显串口
  GUEST_SHOW_SERIAL_PORT: 'GUEST_SHOW_SERIAL_PORT',
}

/**
 * webfunny 点位点ID
 */
export enum WebFunnyEventCode {
  /** 记录页面操作 */
  PAGE = 33,
}